module.exports = __webpack_public_path__ + "static/media/b3.cc2b1a2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/songyimin/b3.mp3
// module id = 4tv1
// module chunks = 0